<template>
  <div class="gameplan">
    <div class='normal_title'>{{channelName}}渠道设置</div>
    <!-- <div class="normal_box">
      <div class="activity_form_box">
        <span class="activity_form">活动形式<span class="activity_form_detail">{{String(themeStyleName)}}</span></span>
      </div>
    </div> -->

    <div class="tab_box">
      <div class="tab">
        <el-tabs v-model="secondActiveName" type="card">
          <el-tab-pane v-for="(item,index) of itemList" :key="index" :label="item[0].themeDetail.themeStyleName"
            :name="item[0].themeDetail.themeStyleName">
            <div class="tab_item_box">
              <div class="tab_item_context">
                <div v-if="item.length>1||item[0].themeDetail.themeLevelName">
                  <el-tabs tab-position="left" style="height: 100%;">
                    <el-tab-pane v-for="(itemChild,index) of item" :key="index" :label="itemChild.themeDetail.themeLevelName">
                      <ConfigDetail ref="configDetailRef" :allInfo="itemChild" @handleSubmit="handleSubmit"
                        :assignAreaList="assignAreaList" :assignRegionList="assignRegionList"
                        :igniteOptions="igniteOptions" :buToCity="buToCity" :assignListParent="assignList"></ConfigDetail>
                    </el-tab-pane>
                  </el-tabs>
                </div>
                <div v-else>
                  <ConfigDetail :allInfo="item[0]" ref="configDetailRef" @handleSubmit="handleSubmit"
                    :assignAreaList="assignAreaList" :assignRegionList="assignRegionList" :igniteOptions="igniteOptions"
                    :buToCity="buToCity" :assignListParent="assignList"></ConfigDetail>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigDetail from './config-info-detail.vue'
import ConfigItemSecondSelect from './config-item-second-select.vue'
import ConfigDetailAssign from './config-detail-assign.vue'
export default {
  name: 'cross-channel-pop',
  components: {
    ConfigDetail,
    //ConfigItemSecondSelect,
    //ConfigDetailAssign
},
  data() {
    return {
      params: {
      },
      secondActiveName: this.themeStyleName[0],
      subAssignList:[],
      itemList:[],
      detailList:[]
    }
  },
  props: {
    configItem: { type: Object, default: () => { } },
    igniteOptions:{ type: Object, default: () => { } },
    themeStyleName: { type: Array, default: () => [] },
    themeStyle: { type: Array, default: () => [] },
    channelName:{ type: String, default:''},
    assignRegionList: { type: Array, default: () => [] },
    assignBuList:{ type: Array, default: () => [] },
    assignAreaList:{ type: Array, default: () => [] },
    detailListLength:{ type: Number, default: 0 },
    buToCity:{ type: Number, default: 0 },
    assignList:{ type: Array, default: () => [] },
  },
  created() {
    this.themeStyle
    let itemIndex =[]
    for(let item of this.themeStyle){
      let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
      if(index===-1){
        itemIndex.splice(itemIndex.length,0,item.themeDetail.themeStyleCode)
        let data = [item]
        this.itemList.push(data)
      }else{
        this.itemList[index].push(item)
      }
    }
  },
  methods: {
    submit(type){
      this.subAssignList = []
      if(this.$refs.configDetailRef&&this.$refs.configDetailRef.length>0){
        for(let i=0;i<this.$refs.configDetailRef.length;i++){
          this.$refs.configDetailRef[i].submit(type)
        }
      }
    },
    handleSubmit(detailItem,isSubmit){
      if(isSubmit){
        this.$emit("handleSubmit",detailItem,isSubmit)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409EFF !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .el-checkbox {
  height: 40px;
}

::v-deep .el-form-item {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}

.activity_form_box {
  width: calc(100% - 60px);
  margin-left: 30px;

  .activity_form_item {
    display: flex;
  }
}


.activity_form{
  //margin: 0px 0 30px 40px;
  font-weight: 600;
  font-size: 15px;
  //height: 30px;
}
.activity_form_detail{
  margin-left: 100px;
}
.activity_form_box{
  margin-bottom:10px;
}

  .item_title{
    display: inline-block;
    width: 200px;
    font-weight: 600;
  }
  .item_detail{
    margin: 20px 15px ;
    display: flex;
  }

  .display_flex{
    display: flex;
  }
  .assign_item{
    width: 200px;
  }


  .tab_box {
  margin-top: 20px;

  .tab_item_box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;

    .tab_item_context {
      height: 100%;
      width: calc(100% - 40px);
      padding: 20px;
    }
  }
}

::v-deep .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
  }

  .el-tabs__item.is-active {
    background: rgb(0, 153, 255);
    color: #fff;
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}

::v-deep .tab_item_context .el-tabs {
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    flex-direction: column;
  }
  .el-tabs__item.is-active {
    color: rgb(0, 119, 255) !important;
    background-color: #fff !important;
  }

  .el-tabs__item {
    min-width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 42px;
    display: inline-block;
    border: none;
    padding: 0px !important;
    background: #fff;
    margin-right: 3px;
    color: black;
    text-align: center;
  }

  .el-tabs__header {
    border-bottom: none;
    margin-bottom: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
</style>
